import { QUERY_CONFIG } from '@/data/gql/misc_queries';
import apolloClient from '@/plugins/apollo';

type ConfigType = { substitute_fee_rate: number; substitute_fee_switch_date: Date; maintenance_mode: boolean };

class Config {
  public async getConfig() {
    const { data } = await apolloClient.defaultClient.query({ query: QUERY_CONFIG, fetchPolicy: 'no-cache' });

    const result: ConfigType = {
      ...data.getConfig,
      substitute_fee_switch_date: new Date(data.getConfig.substitute_fee_switch_date),
    };
    return result;
  }
}

export default new Config();
